export default __webpack_public_path__ + "static/404-5d7478edc4ed2600989ac8c21ac9aa24.png";